import React,{useState,useEffect} from 'react';
import DataTableX from '../../components/datatable/DataTableX';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';





const  ArticlePartDatatable = (props) => {

    const [t] = useTranslation();    
    const [tableName, setTableName] = useState(''); 

    const columns = [       
             { name: "Id", data: "id", selector: "id", omit: true},
             { name: t('general.label.name'), data: "articlePart.name", sortable: true, selector: "articlePart.name", minWidth: '500px'},    		
             { name: t('document.label.qty'), data: "qty", sortable: true, selector: "qty"},    		
             { name: t('article.label.measureUnit'), data: "articlePart.measureUnit",  sortable: true,  selector: "articlePart.measureUnit"},
             { name: t('partner.label.validFrom'), data: "validFrom", sortable: true,  selector: "validFrom"},
             { name: t('partner.label.validTo'), data: "validTo", sortable: true,  selector: "validTo"},
             { name: t('articlePart.label.position'), data: "position", sortable: true,  selector: "position"}                                    
     ];        
 
 
         
     const columnsData = [       
         { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
         { name: t('general.label.name'), data: "articlePart.name",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
         { name: t('document.label.qty'), data: "qty", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('article.label.measureUnit'), data: "articlePart.measureUnit", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('partner.label.validFrom'), data: "validFrom", orderable: true,  searchable: true, search: {value: '',regex: false}},                 
         { name: t('partner.label.validTo'), data: "validTo", orderable: true,  searchable: true, search: {value: '',regex: false}},
         { name: t('articlePart.label.position'), data: "position", orderable: true,  searchable: true, search: {value: '',regex: false}}      
     ];        
     const url = RestService.getBaseURL()+"workOrder/getArticlePartsList?id="+props.selectedRecord;   
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 

     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   

     useEffect(() => {      
        
        RestService.callAnyApi('workOrder/getBom?id='+props.selectedRecord, null)
        .then((data) => {
            setTableName(data.article.name+" ["+data.article.nbr+"]");
        })
        .catch((error) => {
          console.log(error);
        });      
  
      }, [props.selectedRecord])

   
        
          
    
         return (
           
             <DataTableX
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={false}
                 checkTime={props.checkTime}
             />
           
         );
    
 
  
 };

export default ArticlePartDatatable;

